exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message{position:absolute;z-index:99999;left:0;right:0;margin-left:auto;margin-right:auto;width:35%;-webkit-animation:animatetop 2s;animation:animatetop 2s}.message .delete:after,.message .delete:before{background-color:#fff}@-webkit-keyframes animatetop{0%{top:-700px;opacity:0}to{top:0;opacity:1}}@keyframes animatetop{0%{top:-700px;opacity:0}to{top:0;opacity:1}}", ""]);

// exports
